(() => {
  const init = () => document.querySelectorAll('.oa-hero--film').forEach(hero => {
    if (hero.dataset.filmReady) return;
    hero.dataset.filmReady = 'true';
    const video = hero.querySelector('[data-oa-hero-video]');
    const button = hero.querySelector('[data-oa-hero-playback]');
    if (!video || !button) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const label = () => {
      const playing = !video.paused && !video.ended;
      const action = playing ? 'Pause' : video.ended ? 'Replay' : 'Play';
      const icon = document.createElement('span');
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = playing ? 'Ⅱ' : video.ended ? '↻' : '▷';
      button.textContent = `${action} film `;
      button.append(icon);
    };
    video.muted = true;
    video.loop = true;
    ['play','pause','ended'].forEach(event => video.addEventListener(event, label));
    button.addEventListener('click', () => {
      if (!video.paused && !video.ended) video.pause();
      else { if (video.ended) video.currentTime = 0; video.play().catch(label); }
    });
    reduced.addEventListener('change', () => { if (reduced.matches) video.pause(); });
    label();
    if (!reduced.matches) video.play().catch(label);
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
